/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class InputField extends PureComponent {
  render() {
    const { label, value, onChange } = this.props

    return (
      <Form.Field required>
        <label>{label}</label>
        <Input
          required
          placeholder="Please input a message"
          value={value}
          onChange={e => onChange(e.target.value)}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/promotions/fields/inputField.js